import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { buildBookPath, loginRedirectForBook } from '../../utils/bookingAuth';

const BookNowLink = ({ tenantId, branchId, serviceId, className, children, onClick }) => {
  const { isAuthenticated, loading } = useAuth();
  const bookPath = buildBookPath({ tenantId, branchId, serviceId });
  const to = !loading && !isAuthenticated ? loginRedirectForBook(bookPath) : bookPath;

  return (
    <Link to={to} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};

export default BookNowLink;
